import { render, staticRenderFns } from "./PractitionerDetails.vue?vue&type=template&id=3849d5b8&scoped=true&"
import script from "./PractitionerDetails.vue?vue&type=script&lang=js&"
export * from "./PractitionerDetails.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerDetails.vue?vue&type=style&index=0&id=3849d5b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849d5b8",
  null
  
)

export default component.exports